export { useViewer, useViewerDispatch, ViewerProvider } from "./ViewerContext";
export { DrawProvider, useDraw, useDrawDispatch } from "./DrawContext";
export { GraphProvider, useGraph, useGraphDispatch } from "./GraphContext";
export { DataProvider, useData, useDataDispatch } from "./DataContext";
export { ZOrderProvider, useZOrder } from "./ZOrderContext";

export interface PlotProps {
	fieldId: string;
	plotId: string;
	fieldName: string;
	fieldRowsPerPlot: number;
	fieldRowSpacing: number;
	fieldAlleyLength: number;
	plotColumnWidth: number;
	plotRangeLength: number;
	llLat: number;
	llLong: number;
	ulLat: number;
	ulLong: number;
	lrLat: number;
	lrLong: number;
	urLat: number;
	urLong: number;
	analyzed: boolean;
	trialId: string;
	trialName: string;
	companyName: string;
	companyCode?: string;
	crop: string;
	region: string;
	regionCode: string;
	country: string;
	countryCode: string;
	plantDate: string;
	harvestDate: string;
	city: string;
	ranges: number;
	columns: number;
	quantifiedHeight: number;
	quantifiedWidth: number;
	plotName: string;
	displayName: string;
	scaleFactor: number;
	planterOffset: number;
	replicate: number;
	treatment: number;
	treatmentName: string;
	column: number;
	range: number;
	flightDate: string;
	flightId: string;
	status?: string;
	statusIcon?: string;
	level?: string;
	notes?: string;
	quantifiedRegionNames?: { [key: string]: string[] };
	statusOrder?: number;
	levelOrder?: number;
	isAllData?: boolean;
	annotationClassifier?: string;
	modifiedBy?: string;
	modifiedDateTime?: string;
	group?: number;
	superPlot?: number;
}

export interface PlotLLProps extends PlotProps {
	bearing: number;
	iconScaleFactor: number;
}

export interface HeatmapData {
	plotId: string;
	flightId?: string;
	flightDataAnalysisId?: string;
	analysisId: string;
	analysisTypeId: string;
	analysisTypeName: string;
	assessmentId?: string;
	curveModelAnalysisId?: string;
	curveModelDataAnalysisId?: string;
	plotAnalysisResultValue: number;
	quantifiedRegionTypeId?: string;
	dateCollected?: string;
	datasetId?: string;
	isPlotUniformityValue: boolean;
	excluded: boolean;
}
